import React, {ReactNode} from "react"
import Box, {Direction} from "./Box";

interface Props {
    firstChild: ReactNode,
    secondChild: ReactNode
}

export default (props: Props) => {
    const {firstChild, secondChild} = props;

    return (
        <Box direction={Direction.Column}>
            <Box>
                <Box flex direction={Direction.Column}>
                    {firstChild}
                </Box>
                <Box shrink leftMargin={10}>
                    {secondChild}
                </Box>
            </Box>
        </Box>
    );
}
